// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b55bcc80","180":"ff62f641","208":"c228c356","631":"49ec9bbb","774":"385a2293","820":"b8343dd4","910":"1f4e68dd"}[chunkId] + ".chunk.js";
};